import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ButtonDirective } from './button.directive';
import { ThemedBackgroundComponent } from './themed-background/themed-background.component';
import { ThemedButtonDirective } from './themed-button.directive';

@NgModule({
  declarations: [ThemedBackgroundComponent, ThemedButtonDirective, ButtonDirective],
  imports: [CommonModule, MatButtonModule],
  exports: [ThemedBackgroundComponent, ThemedButtonDirective, ButtonDirective]
})
export class ThemeModule {}
